import { render } from "./UserClockingIn.vue?vue&type=template&id=3a5da7e8&scoped=true&ts=true&lang=pug"
import script from "./UserClockingIn.vue?vue&type=script&lang=ts"
export * from "./UserClockingIn.vue?vue&type=script&lang=ts"

import "./UserClockingIn.vue?vue&type=style&index=0&id=3a5da7e8&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5da7e8"]])

export default __exports__